import { RouteConfig } from 'vue-router';
import { importPage } from '@/utils/import';

export const routes: RouteConfig[] = [
  { path: '/user', component: importPage('user/user') },
  { path: '/user/login', component: importPage('user/login') },
  { path: '/user/orders', component: importPage('user/orders') },
  { path: '/user/order', component: importPage('user/order') },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routers/user.ts